import { createContext } from "react";

const aaraContext = createContext();

export default aaraContext;
